import React from 'react';
import HighBloodPressureIcon from '../assets/HighBloodPressureIcon.jpg';
import HeadacheIcon from '../assets/HeadacheIcon.jpg';
import KidneyStonesIcon from '../assets/KidneyStonesIcon.jpg';
import HeartSymptomsIcon from '../assets/HeartSymptomsIcon.jpg';
import UtiIcon from '../assets/UtiIcon.jpg';
import AbdominalPainIcon from '../assets/AbdominalPainIcon.jpg';
import EnlargedAbdomenIcon from '../assets/EnlargedAbdomenIcon.jpg';
import LiverIcon from '../assets/LiverIcon.jpg';
import HematuriaIcon from '../assets/HematuriaIcon.jpg';
import KidneyDeclineIcon from '../assets/KidneyDeclineIcon.jpg';

const features = [
  { icon: HighBloodPressureIcon, title: "High Blood Pressure", text: "Often the first sign, affects 60% of patients" },
  { icon: HeadacheIcon, title: "Headache", text: "May indicate intracranial aneurysm risk" },
  { icon: KidneyStonesIcon, title: "Kidney Stones", text: "Occur in about 20% of ADPKD patients" },
  { icon: HeartSymptomsIcon, title: "Heart related symptoms", text: "Mitral valve prolapse in 25% of patients" },
  { icon: UtiIcon, title: "UTIs", text: "Symptoms may include fever, painful urination and urgency" },
  { icon: AbdominalPainIcon, title: "Abdominal pain", text: "Due to enlarged kidneys and cyst complications" },
  { icon: EnlargedAbdomenIcon, title: "Enlarged Abdomen", text: "Abdominal swelling or a sensation of fullness" },
  { icon: LiverIcon, title: "Liver", text: "Symptoms may include fever, painful urination and urgency" },
  { icon: HematuriaIcon, title: "Hematuria", text: "Blood in urine form cyst rupture or stones" },
  { icon: KidneyDeclineIcon, title: "Kidney Decline", text: "Leading to fatigue, swelling and eventually kidney failure" },
];

const ClinicalFeatures = () => {
  return (
    <section className="section clinical-features-section">
      <div className="container">
        <h2 className="section-title">Clinical Features of PKD</h2>
        <div className="clinical-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <img src={feature.icon} alt={feature.title} />
              </div>
              <div className="feature-text">
                <h4>{feature.title}</h4>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClinicalFeatures;